import { inject, Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { ApiDataService } from "src/app/api/services/api-data.service";
import { NavigationItem } from "src/app/controls/menu/models/navigation-item.interface";

@Injectable({
    providedIn: 'root'
})
export class NavigationService {

    private service = inject(ApiDataService);

    /** Side navigation emitter reference */
    public closeSideNav = new BehaviorSubject<void>(undefined);

    /**
     * Obtains competitions navigation menu items
     */
    getCompetitions(): Observable<NavigationItem> {
        return this.service.get<NavigationItem>('navigation/competitions');
    }
}